import * as DayStyles from './components/Day/Day.css';
import * as WeekCalendarStyles from './components/WeekCalendar.css';
import * as SliderStyles from './components/Slider/Slider.css';
const defaultTheme = {
    DayStyles,
    WeekCalendarStyles,
    SliderStyles
};
export default defaultTheme;
